__turbopack_context__.v({
  "carouselArrow": "CustomArrowWrapper-module-scss-module__XDzGqa__carouselArrow",
});
